// Side-effect module: extends Zod with .openapi() metadata method.
// Imported once at the top of packages/contracts/src/index.ts so every
// schema in the package can use .openapi() without redundant imports.
//
// ADR-0005 line 13: "OpenAPI 3.1 auto-generated via @hono/zod-openapi.
// Client types via openapi-typescript."
import { extendZodWithOpenApi } from '@hono/zod-openapi';
import { z } from 'zod';
extendZodWithOpenApi(z);
// Re-export z so consumers import from this module rather than 'zod'
// directly when they want the openapi-extended version.
export { z };
//# sourceMappingURL=zod-openapi-init.js.map